import "./assets/main.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import ToastPlugin from "vue-toast-notification";
import VueCookies from "vue-cookies";
import "vue-toast-notification/dist/theme-bootstrap.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import "./assets/theme-tech.css";
import "./assets/theme-atmosphere.css";
import "./assets/theme-ios.css";
import "./assets/theme-liquid-glass.css";
import "@element-plus/icons";
import "@/utils/flexible.js";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(VueCookies);
app.use(ElementPlus);
app.use(ToastPlugin, {
  // One of the options
  position: "top",
});

app.mount("#app");
